"use strict";
/**
 * Created on 04 22 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link WindowItemProductSuppliers}
 *
 * @author JMe
 */


var WindowItemProductSuppliersConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemProductSuppliersConverter, _DataObjectConverter_);

  function WindowItemProductSuppliersConverter() {
    _classCallCheck(this, WindowItemProductSuppliersConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemProductSuppliersConverter).apply(this, arguments));
  }

  return WindowItemProductSuppliersConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemProductSuppliersConverter = WindowItemProductSuppliersConverter;